import { NavigateOptions, useNavigate } from 'react-router-dom';

export const useTopScrollNavigate = () => {
  const navigate = useNavigate();

  const onNavigate = (path: string, options?: NavigateOptions) => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
    navigate(path, options);
  };

  return onNavigate;
};
